import { Colors } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Icon24 from 'builder/components/Icon'

export const ColorsIcon = styled(Icon24.Colors)`
  color: ${Colors.Blue50};
`
